import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget } from '@eforall/dashboard';
import { DomainDataService } from '../../../../../services';
import { ReadonlyAccessWidget } from '../../../readonly-access/readonly-access.widget';
import { AccSessionViewerDialogDataService } from '../acc-session-viewer-dialog-data.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'acc-session-sign-ups-part',
	standalone: true,
	imports: [
		GridContentWidget,
		ReadonlyAccessWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './sign-ups.part.html',
})
export class AccSessionSignUpsPart {

	public dialogBodyHeight = input.required<number>();

	private readonly dialogService = inject(DialogService);
	public readonly service = inject(AccSessionViewerDialogDataService);
	private util = inject(UtilityService);
	private readonly domainData = inject(DomainDataService);

	public setup = getSetup(this.service, this.util, this.dialogService, this.domainData);

	// subtracting 70 to account for padding and tabstrip, and 45 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 70 - (this.service.isReadonly() ? 45 : 0));

	public readonly specialists = computed(() => (this.service.accSessionDetails()?.specialists ?? []).map(s => ({ ...s, updatedUTC: 0 })));
}